import React, { Component } from 'react';
import Card from '../../components/Card';
import CardHeader from '../../components/CardHeader';
import Select from '../../components/Select';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const Title = styled.div``;

const PreferencesContainer = styled.div`
  .preferencesCardContent {
    display: flex;
    flex-direction: column;
    margin-left: 41px;
    margin-right: 50px;
  }
  .errorPassword {
    margin-left: 41px;
    color: red;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
  }

  .preferencesUpdateButton {
    margin-left: auto;
    margin-right: 40px !important;
    height: 45px;
    width: calc(50px + 5vw) !important;
    border-radius: 3.2px;
    background-color: #fafafa;
    color: black;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 13.6px;
    font-weight: bold;
    text-align: center;
    color: #4a4a4a;
  }

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 3vh;
  }

  .hidePasswordIcon {
    position: absolute;
    right: 21px;
    top: 38px;
    color: #e8eaeb;
  }
  .hidePasswordIcon:hover {
    cursor: pointer;
  }
  .inputContainer {
    position: relative;
  }

  @media (min-width: 801px) {
    .inputContainer {
      width: calc((100% - 30px) / 2);
    }

    .inputContainer:not(:last-child) {
      margin-right: 30px;
    }

    > div {
      min-height: 450px !important;
      background-color: white;
    }
  }

  @media (max-width: 800px) {
    .row {
      flex-direction: column;
      margin-bottom: 0px;
    }
    .inputContainer {
      width: 100%;
      margin-right: 0px;
      margin-bottom: 3vh;
    }
  }

  hr {
    color: #adb5bd;
    opacity: 0.2;
    width: 100%;
    margin-bottom: 3vh;
  }
`;

const options = {
  lang: [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'Français' },
    { value: 'it', label: 'Italiano' }
  ],
  timezone: [
    { value: 'Australia/Adelaide', label: 'Australia/Adelaide' },
    { value: 'America/Los_Angeles', label: 'America/Los_Angeles' },
    {
      value: 'America/Argentina/Buenos_Aires',
      label: 'America/Argentina/Buenos_Aires'
    },
    { value: 'America/Argentina/Mendoza', label: 'America/Argentina/Mendoza' },
    { value: 'America/Santiago', label: 'America/Santiago' },
    { value: 'Europe/Berlin', label: 'Europe/Berlin' },
    { value: 'Europe/London', label: 'Europe/London' },
    { value: 'Europe/Madrid', label: 'Europe/Madrid' },
    { value: 'Europe/Paris', label: 'Europe/Paris' },
    { value: 'Europe/Rome', label: 'Europe/Rome' },
    { value: 'Pacific/Auckland', label: 'Pacific/Auckland' },
    { value: 'US/Pacific', label: 'US/Pacific' },
    { value: 'US/Mountain', label: 'US/Mountain' },
    { value: 'US/Eastern', label: 'US/Eastern' }
  ]
};

class Preferences extends Component {
  constructor(props) {
    super(props);
  }

  valueToSelectOption(options, value) {
    return options.find((option) => option.value === value);
  }

  formatOptions() {
    let { data } = this.props;

    // Currency settings
    const defaultCurrency = { label: 'Euro', value: 'EUR' };
    const isoCodeToFilterInCurrency = ['EUR', 'GBP', 'USD'];

    // Currencies
    const currencies = this.props.currencies
      .filter(({ iso_code }) => isoCodeToFilterInCurrency.includes(iso_code))
      .map(({ id, name }) => ({ value: id, label: name }));
    const selectedCurrency = this.valueToSelectOption(
      currencies,
      data.selectedCurrency
    );

    const lang = this.valueToSelectOption(options.lang, data.selectedLang);
    const selectedTimezone = this.valueToSelectOption(
      options.timezone,
      data.selectedTimezone
    );
    return {
      lang,
      selectedCurrency:
        selectedCurrency !== undefined ? selectedCurrency : defaultCurrency,
      selectedTimezone,
      currencies
    };
  }

  render() {
    let { onChange } = this.props;
    let { lang, selectedCurrency, selectedTimezone, currencies } =
      this.formatOptions();

    return (
      <PreferencesContainer>
        <Card>
          <Title>
            <CardHeader
              textTransform="normal"
              title={I18n.t('admin.preferences')}
              icon="settings"
              iconPosition="left"
              iconContainer
            />
          </Title>
          <div className="preferencesCardContent">
            <div className="row">
              <div className="inputContainer">
                <Select
                  label={I18n.t('admin.preferencesInputs.language')}
                  dropdownProps={{
                    styles: `margin-left:-25px;`
                  }}
                  options={options.lang}
                  value={lang}
                  customStyles={{
                    container: { fontSize: 11 },
                    control: { fontSize: 11 },
                    menu: { fontSize: 11 }
                  }}
                  onChange={(value) => onChange('selectedLang', value.value)}
                />
              </div>
              <div className="inputContainer">
                <Select
                  label={I18n.t('admin.preferencesInputs.currency')}
                  dropdownProps={{ styles: `margin-left:-25px` }}
                  customStyles={{
                    container: { fontSize: 11 },
                    control: { fontSize: 11 },
                    menu: { fontSize: 11 }
                  }}
                  options={currencies}
                  value={selectedCurrency}
                  onChange={(value) =>
                    onChange('selectedCurrency', value.value)
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="inputContainer">
                <Select
                  label={I18n.t('admin.preferencesInputs.timezone')}
                  dropdownProps={{ styles: `margin-left:-25px` }}
                  options={options.timezone}
                  value={selectedTimezone}
                  customStyles={{
                    container: { fontSize: 11 },
                    control: { fontSize: 11 },
                    menu: { fontSize: 11 }
                  }}
                  onChange={(value) =>
                    onChange('selectedTimezone', value.value)
                  }
                />
              </div>
            </div>
          </div>
        </Card>
      </PreferencesContainer>
    );
  }
}

export default Preferences;
